export default "__VITE_ASSET__Dx10pCem__"